import React from "react";
import { useTranslate } from "react-admin";

const IdentityTitle = ({ record }) => {
    const translate = useTranslate();

    return (
        <span>
            {
                ! record ?    translate("identity.message.list") :
                ! record.id ? translate("identity.message.new") :
                              translate("identity.message.instance", { ...record })
            }
        </span>
    );
}

export default IdentityTitle;
